export const HANDLE_GET_MEASUREMENT_GROUP_LIST="HANDLE_GET_MEASUREMENT_GROUP_LIST";
export const HANDLE_GET_MEASUREMENT_GROUP_INDIVIDUAL="HANDLE_GET_MEASUREMENT_GROUP_INDIVIDUAL"
export const HANDLE_GET_MEASUREMENT_LIST="HANDLE_GET_MEASUREMENT_LIST"; 
export const HANDLE_UPDATE_MEASUREMENT_DEF="HANDLE_UPDATE_MEASUREMENT_DEF"; 
export const HANDLE_CUSTOMISE_MESUREMENT_UPDATE="HANDLE_CUSTOMISE_MESUREMENT_UPDATE"; 
export const HANDLE_GET_MEASUREMENT_DEF="HANDLE_GET_MEASUREMENT_DEF";